export default "__VITE_ASSET__CehoT0vt__"